<div class="filter-control">
  <ng-container *ngIf="(isDesktop$ | async)!; else button">
    <mzima-client-button
      #button
      fill="clear"
      color="gray"
      [matMenuTriggerFor]="menu"
      class="filter-control__button"
    >
      <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </mzima-client-button>

    <mat-menu
      #menu="matMenu"
      [class]="
        'filter-control-menu' +
        (type === filterType.Daterange || type === filterType.Location
          ? ' filter-control-menu--wide'
          : '')
      "
    >
      <div
        class="menu-content"
        [ngStyle]="{
          width:
            (type === filterType.Daterange || type === filterType.Location
              ? buttonWidth * 2
              : buttonWidth) + 'px'
        }"
      >
        <ng-container *ngTemplateOutlet="control"></ng-container>
      </div>
    </mat-menu>
  </ng-container>
</div>

<ng-template #control>
  <ng-container [ngSwitch]="type">
    <ng-content select="[suffix]"></ng-content>
    <ng-container *ngSwitchCase="filterType.Select">
      <mat-radio-group
        [(ngModel)]="value"
        (ngModelChange)="valueChanged()"
        (change)="filterChange.emit($event.value)"
      >
        <div class="radio-button">
          <mat-radio-button>
            {{ 'graph.none' | translate }}
          </mat-radio-button>
        </div>
        <div class="radio-button" *ngFor="let option of options">
          <mat-radio-button
            [value]="option[fields[0]]"
            [checked]="option.checked"
            [disabled]="option.disabled"
          >
            {{ option[fields[1]] | translate }}
          </mat-radio-button>
          <mzima-client-button
            *ngIf="canEdit && isEditable(option)"
            class="edit-btn"
            [iconOnly]="true"
            fill="clear"
            color="secondary"
            (buttonClick)="editOption.emit(option)"
          >
            <mat-icon icon svgIcon="pencil"></mat-icon>
          </mzima-client-button>
        </div>
      </mat-radio-group>
      <ng-content select="[postfix]"></ng-content>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.Multiselect">
      <mat-selection-list
        [(ngModel)]="value"
        (ngModelChange)="valueChanged()"
        (click)="$event.stopPropagation()"
        (selectionChange)="filterChange.emit($event)"
        [attr.data-qa]="'filter-selection-list'"
      >
        <mat-list-option
          color="primary"
          class="checkbox-option"
          checkboxPosition="before"
          [value]="option[fields[0]]"
          [selected]="option.checked"
          [disabled]="option.disabled"
          *ngFor="let option of options"
          [attr.data-qa]="'filter-list-option'"
        >
          {{ option[fields[1]] | translate }}
        </mat-list-option>
      </mat-selection-list>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.Multilevelselect">
      <div class="clear-button" suffix>
        <mzima-client-button
          fill="clear"
          size="small"
          class="filter-group__head__button"
          (buttonClick)="clearTags()"
        >
          {{ 'nav.clear' | translate }}
        </mzima-client-button>
      </div>
      <mat-tree
        [dataSource]="dataSource"
        [treeControl]="treeControl"
        class="multilevelselect-filter"
      >
        <mat-selection-list [(ngModel)]="value" (selectionChange)="valueChanged()">
          <mat-tree-node *matTreeNodeDef="let node">
            <mat-checkbox
              color="primary"
              [value]="node.id"
              (click)="$event.stopPropagation()"
              class="multilevelselect-filter__option"
              (change)="categoryLeafSelectionToggle(node)"
              [checked]="checklistSelection.isSelected(node)"
            >
              {{ node.name | translate }}
            </mat-checkbox>
          </mat-tree-node>
          <mat-tree-node
            (click)="$event.stopPropagation()"
            *matTreeNodeDef="let node; when: hasChild"
          >
            <mat-checkbox
              color="primary"
              [value]="node.id"
              (click)="$event.stopPropagation()"
              [indeterminate]="descendantsPartiallySelected(node)"
              class="multilevelselect-filter__option"
              [checked]="descendantsAllSelected(node)"
              (change)="categorySelectionToggle(node)"
            >
              {{ node.name | translate }}
            </mat-checkbox>
            <mzima-client-button
              fill="clear"
              [iconOnly]="true"
              color="secondary"
              matTreeNodeToggle
              class="multilevelselect-filter__option__arrow checklist-leaf-node"
              [attr.aria-label]="'Toggle ' + node.name"
              [ngClass]="{
                'multilevelselect-filter__option__arrow--open': treeControl.isExpanded(node)
              }"
            >
              <mat-icon icon svgIcon="arrow-down"></mat-icon>
            </mzima-client-button>
          </mat-tree-node>
        </mat-selection-list>
      </mat-tree>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.Daterange">
      <div class="daterange" *ngIf="value" (click)="$event.stopPropagation()">
        <div
          class="daterange-display"
          [ngClass]="{ 'daterange-display__grey': !dateIsValid(value.start) }"
        >
          <span class="daterange-display__sm">{{ displayDateRange() }}</span>
        </div>
        <mat-calendar #calendar [selected]="value" (selectedChange)="selectedChange($event)">
        </mat-calendar>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.Location">
      <app-location-selection
        [(ngModel)]="value"
        class="location-select"
        (ngModelChange)="valueChanged()"
        (click)="$event.stopPropagation()"
      >
      </app-location-selection>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #buttonContent>
  <span>{{ title }}</span>
  <span class="filter-control__button__count" *ngIf="badge">{{ badge }}</span>
  <mat-icon
    class="filter-control__button__arrow"
    [svgIcon]="(isDesktop$ | async)! ? 'arrow-down-thin' : 'arrow-down'"
  ></mat-icon>
</ng-template>

<ng-template #button>
  <mzima-client-button
    fill="clear"
    color="secondary"
    class="filter-control__button"
    (buttonClick)="toggleModal(true)"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </mzima-client-button>

  <div class="filter-modal" *ngIf="isModalOpen">
    <div class="filter-modal__head">
      <mzima-client-button
        fill="clear"
        [iconOnly]="true"
        color="secondary"
        class="filter-modal__back"
        (buttonClick)="toggleModal(false)"
      >
        <mat-icon icon svgIcon="back"></mat-icon>
      </mzima-client-button>
      <h1>{{ title }}</h1>
    </div>

    <div class="filter-modal__content">
      <ng-container *ngTemplateOutlet="control"></ng-container>
    </div>

    <div class="filter-modal__controls">
      <mzima-client-button
        fill="outline"
        color="secondary"
        (buttonClick)="clearFilter()"
        class="filter-modal__control"
      >
        {{ 'nav.clear' | translate }}
      </mzima-client-button>
      <mzima-client-button (buttonClick)="apply()" class="filter-modal__control">
        {{ 'app.apply_filters' | translate }}
      </mzima-client-button>
    </div>
  </div>
</ng-template>
